/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { ErrorHandler, Injectable, Injector, inject } from '@angular/core';
import StackTrace from 'stacktrace-js';
import { ClientErrorLoggerService } from './client-error-logger.service';
import { isStaleBuildError } from './util/stale-build-error';

/** Sends client-side error messages to an endpoint to be logged */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
	private injector = inject(Injector);

	private static _numberOfErrors = 0;


	// Note that the error handler is potentially run very
	// early in the Angular pipeline and therefore not all dependencies
	// can be injected.
	constructor() {}

	handleError(error: any): void {
		try {
			console.error(error);

			// A stale build is recoverable by refreshing and is handled by
			// StaleBuildService, so don't spend the error budget on it.
			if (isStaleBuildError(error)) return;

			GlobalErrorHandler._numberOfErrors += 1;
			const maxErrorsToLog = 3;

			// Avoid spamming the error logs
			if (GlobalErrorHandler._numberOfErrors > maxErrorsToLog) return;

			const clientErrorLoggerService = this.injector.get(ClientErrorLoggerService);

			if (!clientErrorLoggerService.isEnabled) return;

			let stackString;

			StackTrace.fromError(error)
				.then((stackframes) => {
					stackString = stackframes
						.splice(0, 20)
						.map(function (sf) {
							return sf.toString();
						})
						.join('\n');
				})
				// Ignore errors getting stack trace (important, because
				// stacktrace-js is kind of buggy)
				.catch(() => {})
				.finally(() => {
					clientErrorLoggerService.logClientError(error, stackString);
				});
		} catch (error2) {
			console.warn('Error logging error: ' + error2.toString());
		}
	}
}
